import styles from './FJAdvertisingItem.module.less';
import PropTypes from 'prop-types';
import FJArrowIcon from '../../../../assets/svg/community/arrow.svg?react';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import useIsInViewport from '../../../../hooks/useIsInViewPort.jsx';
import { useEffect, useRef, useState } from 'react';
import FJUtil from '../../../../util/FJUtil.js';
import FJVideoUtil from '../../../../util/FJVideoUtil.js';
import FJCoverVideo from '../../../../common/components/FJCoverVideo/FJCoverVideo.jsx';
import FJCoverImage from '../../../../common/components/FJCoverImage/FJCoverImage.jsx';
const FJAdvertisingItem = props => {
    const { data } = props;

    const { desc, url, href, mediaType, openNew, coverUrl } = data;
    const [_containerRef, isVisible] = useIsInViewport();
    const [showVideo, setShowVideo] = useState(false);
    const _videoRef = useRef(null);
    useEffect(() => {
        let timer = null;
        if (isVisible) {
            timer = setTimeout(() => {
                setShowVideo(true);
                clearTimeout(timer);
            }, 1000);
        } else {
            setShowVideo(false);
            clearTimeout(timer);
        }
    }, [isVisible]);
    useEffect(() => {
        if (!_videoRef.current) return;
        if (showVideo) {
            _videoRef.current.src = url;
        } else {
            FJVideoUtil.releaseVideo(_videoRef.current);
        }
    }, [showVideo, url]);
    const _onClick = e => {
        FJUtil.forbidEvent(e);
        if (href && openNew) {
            window.open(href, '_blank');
        } else if (href) {
            window.location.href = href;
        }
        FJUtil.eaLog('ai home ad click', {
            link: href,
        });
    };
    const _renderContent = () => {
        return (
            <div className={styles.footer}>
                {desc && <FJTextWithEllipsis text={desc} className={styles.desc} />}
                <FJArrowIcon className={styles.arrowIcon} />
            </div>
        );
    };
    const _renderImage = () => {
        return (
            <>
                <FJCoverImage
                    coverImg={url}
                    imgSrc={url}
                    boxClassName={styles.media_box}
                    isShowLoading={true}
                    imgClassName={styles.media}
                    addRefreshEvent={true}
                >
                    {_renderContent()}
                </FJCoverImage>
            </>
        );
    };
    const _renderVideo = () => {
        return (
            <FJCoverVideo
                videoSrc={url}
                videoClassName={styles.media}
                boxClassName={styles.media_box}
                coverImage={coverUrl}
                coverVideo={url}
                autoPlay={true}
            >
                {_renderContent()}
            </FJCoverVideo>
        );
    };

    return (
        <div className={styles.container} onClick={_onClick} ref={_containerRef}>
            {mediaType === 'IMAGE' ? _renderImage() : _renderVideo()}
        </div>
    );
};

FJAdvertisingItem.propTypes = {
    data: PropTypes.object.isRequired,
};

export default FJAdvertisingItem;
